













































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { BankCustodian } from "@/admin/types";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import PartnerSupport from "@/admin/components/partners/PartnerSupport.vue";
import PartnerLogoUpload from "@/admin/components/partners/PartnerLogoUpload.vue";
import DebitCardImageUpload from "@/admin/components/partners/DebitCardImageUpload.vue";
import HsaStoreConfiguration from "@/admin/components/partners/HsaStoreConfiguration.vue";
import PartnerSettings from "@/admin/components/partners/PartnerSettings.vue";
import CardCustomizationSection from "@/admin/components/partners/CardCustomizationSection.vue";
import AvidiaBranchAndCostCenterSection from "@/admin/components/partners/AvidiaBranchAndCostCenterSection.vue";
import PartnerContentSection from "@/admin/components/partners/PartnerContentSection.vue";
import { useCardCustomizationStore } from "@/admin/store/cardCustomization";
import { usePartnerStore } from "@/admin/store/partner";
import { useAvidiaPartnerStore } from "@/admin/store/avidiaPartner";
import AchBranding from "@/admin/components/partners/AchBranding.vue";

@Component({
  components: {
    HsaStoreConfiguration,
    PartnerSupport,
    PartnerLogoUpload,
    DebitCardImageUpload,
    PartnerSettings,
    CardCustomizationSection,
    AvidiaBranchAndCostCenterSection,
    PartnerContentSection,
    AchBranding
  }
})
export default class PartnerCustomization extends Vue {
  $router: VueRouter;
  $validator: Validator;

  @Prop() partnerId: string;

  @Prop() routeToPartnerList: () => Location;

  partnerStore = usePartnerStore();
  cardCustomizationStore = useCardCustomizationStore();
  avidiaPartnerStore = useAvidiaPartnerStore();

  created () {
    this.partnerStore.reload(false);
  }

  get custodian () {
    const partner = this.partnerStore.partnerWithId(parseInt(this.partnerId));
    return partner ? partner.custodian : BankCustodian.None;
  }

  get canCustomize () {
    return this.cardCustomizationStore.canCustomizeCards(this.custodian);
  }

  get canManage () {
    return this.avidiaPartnerStore.canManageBranchAndCostCenter(this.custodian);
  }
}
